import {
    DELETE_CUSTOMER_DEMO_REQUEST,
    DELETE_CUSTOMER_DEMO_SUCCESS,
    DELETE_CUSTOMER_DEMO_FAILURE
} from '../../../../Constants/actionTypes';
import { deleteCustomerDemoSession } from '../../../../Constants/apiService'


// Fetch Sales Request Action
export const deleteDemoSessionRequest = () => ({
    type: DELETE_CUSTOMER_DEMO_REQUEST,
});

// Fetch Sales Success Action
export const deleteDemoSessionSuccess = (salesData) => ({
    type: DELETE_CUSTOMER_DEMO_SUCCESS,
    payload: salesData,

});

// Fetch Sales Failure Action
export const deleteDemoSessionFailure = (error) => ({
    type: DELETE_CUSTOMER_DEMO_FAILURE,
    payload: error,
});

 

// Thunk Action Creator for Fetching Sales
export const deleteCustomerDemoSessionAct = () => {
  
    return async (dispatch, getState) => {
        dispatch(deleteDemoSessionRequest());

        const state = getState();
        const accessToken = state.auth.accessToken;


        try {
            const data = await deleteCustomerDemoSession(accessToken);
             // Check if the response has the expected `success` key
             // Check if the response has the expected `success` key
             if (data?.success) {
                console.log('Success:', data.success);
                dispatch(deleteDemoSessionSuccess(data.success)); // Pass the success message
                return data; // Return the response to the caller
            } else {
                throw new Error('Unexpected API response format');
            }
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch(deleteDemoSessionFailure(errorMessage));
        }
    };
};
